/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：マニュアルコンフィグ
 *
 * 作成者：2021/11/24 ノア）黄
 * 最終修正者：2021/12/2 ノア）黄
 *
 */

// マニュアルbase url
const manualEnterPoint = '/manual'

/**
 * マニュアルコンフィグ
 *
 * @constant
 */
const manualConfig: Record<string, Record<string, string>> = {
  route: {
    // 利用規約
    agreement: `${manualEnterPoint}/Agreement.html`,
    // このシステムについて
    aboutMe: `${manualEnterPoint}/AboutMe.html`,
    // マニュアル
    help: `${manualEnterPoint}/Help.html`,
    // 機能一覧
    homeScreens: `${manualEnterPoint}/Help.html#7.1.1`,
    // 電話CC
    phoneCC: `${manualEnterPoint}/Help.html#1.7.1`,
    // 通知登録
    notificationsSend: `${manualEnterPoint}/Help.html#1.6.5`,
    // メッセージ送信
    messageSend: `${manualEnterPoint}/Help.html#1.6.3`,
    // お気に入り
    homeFav: `${manualEnterPoint}/Help.html#1.5.1`,
    // パスワード変更
    updatePassword: `${manualEnterPoint}/Help.html#1.2.1`,
    // 管理場所登録マスタ画面 位置情報
    locationInfo_mgmt: `${manualEnterPoint}/Help.html#5.6.1`,
    // 営業所マスタ画面 位置情報
    locationInfo_sales: `${manualEnterPoint}/Help.html#5.8.1`,
    // 画像選択
    cropper: `${manualEnterPoint}/Help.html#5.6.1`,
    // 稼働実績
    reallyOutput: `${manualEnterPoint}/Help.html#3.2.3`,
    // 受信回数カウント
    trustedRepliesCount: `${manualEnterPoint}/Help.html#5.5.3`,
    // MFA認証設定
    mfaSet: `${manualEnterPoint}/Help.html#1.3.1`
  }
}

export default manualConfig
